import { ITALogo } from "assets";
import { IKnowledgeSection } from "./types";

const indirectTax: IKnowledgeSection = {
  key: "indirectTax",
  title: "Indirect Tax",
//   icon: ITALogo,
  color: "#059669",
  // TODO: these are placeholders copied from Income Tax — swap in the real
  // Direct Tax links. Two sections must not share a href, or their cards clash
  // in the "All" view.
  links: [
    {
      title: "Aadhaar Authentication for Existing Taxpayers (Regular and Composition) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=manual_aadhaar.htm",
    },
    {
      title: "Accessing and Responding to Communications Received as part of Enforcement Case Proceedings [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/enforcement/index.htm#t=Manual.htm",
    },
    {
      title: "Adjustment of Demand using payment made in DRC 03 (GST DRC-03A) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/demandsandrecovery/index.htm#t=Manual_Adjustment_Demand_payment_DRC03.htm",
    },
    {
      title: "Advance Ruling for Registered Taxpayer [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/advanceruling/index.htm#t=Manual_Advance_Ruling_for_Registered_Taxpayers.htm",
    },
    {
      title: "Advance Ruling for Unregistered Dealers [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/advanceruling/index.htm#t=Manual_Advance_Ruling_for_Unregistered_Dealers.htm",
    },
    {
      title: "Amendment of Core Fields [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Core_Fields_Manual.htm",
    },
    {
      title: "Amendment of Non-Core Fields [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Non-Core_Fields.htm",
    },
    {
      title: "Amendment of Outward Supplies of Goods or Services for Current Tax Period in GSTR-1A [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_Creation_of_Outward_Supplies_Return_in_GSTR-1A.htm",
    },
    {
      title: "Annual Return by Composition Dealer in GSTR-4 (for FY 2019-20 Onwards) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=manual_GSTR4annual.htm",
    },
    {
      title: "Annual Return in GSTR-9 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_gstr9.htm",
    },
    {
      title: "Application for Extension of Registration Period for CTP/NRTP [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Application_for_Extension_manual.htm",
    },
    {
      title: "Application for Unbarring Returns [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_application_Unbarring.htm",
    },
    {
      title: "Application for Waiver of Interest and Penalty [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/demandsandrecovery/index.htm#t=Manual_Application_for_Waiver_of_Interest_and_Penalty.htm",
    },
    {
      title: "Applying for Cancellation of Enrolment by GST Practitioner [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/gstp/index.htm#t=Manual_cancellation_gstp.htm",
    },
    {
      title: "Applying for Deferred Payment or Payment in Instalments (GST DRC-20) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/demandsandrecovery/index.htm#t=manual_application_for_deferred_payment.htm",
    },
    {
      title: "Applying for GST Registration on MCA website [FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=faq_spice_form.htm",
    },
    {
      title: "Applying for Refund of Export of Electricity without Payment of Tax (accumulated ITC ) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Manual_Export_of_Electricity_without_Payment_of_Tax_(accumulated_ITC).htm",
    },
    {
      title: "Applying for Registration as Casual Taxable Person [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Apply_for_Registration_Normal_Taxpayer.htm&rhtocid=_1_2_0",
    },
    {
      title: "Applying for Registration as Composition Taxpayer [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Apply_for_Registration_Normal_Taxpayer.htm&rhtocid=_1_1_0",
    },
    {
      title: "Applying for Registration as Embassy [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Manual_Embassy.htm",
    },
    {
      title: "Applying for Registration as ISD [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Apply_for_Registration_Normal_Taxpayer.htm&rhtocid=_1_3_0",
    },
    {
      title: "Applying for Registration as Non-Resident Taxable Person [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Registration_-_Non-Resident_Foreign_Taxpayer.htm",
    },
    {
      title: "Applying for Registration as Normal Taxpayer [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Apply_for_Registration_Normal_Taxpayer.htm",
    },
    {
      title: "Applying for Registration as OIDAR [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Non-Resident_Online_Services_Provider_manual.htm",
    },
    {
      title: "Applying for Registration as Other Notified Person [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Manual_Other_Notified_Person.htm",
    },
    {
      title: "Applying for Registration as SEZ Unit/Developer [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Apply_for_Registration_Normal_Taxpayer.htm&rhtocid=_1_7_0",
    },
    {
      title: "Applying for Registration as Tax Collector [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Tax_collector.htm",
    },
    {
      title: "Applying for Registration as Tax Deductor [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Tax_Deductor.htm",
    },
    {
      title: "Applying for Registration as UN Body [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Registration_as_a_UN_Bodies.htm",
    },
    {
      title: "Applying for Temporary User ID for Unregistered User [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Manual_reg_temp.htm",
    },
    {
      title: "Auto Drafted details for Registered Persons opting Composition Levy [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_4A.htm",
    },
    {
      title: "Auto Drafted Dynamic Details in GSTR-2A [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=View_of_Inward_Supplies_Returns_1.htm",
    },
    {
      title: "Cancellation of Registration [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Cancellation_of_Registration_manual.htm",
    },
    {
      title: "Cancellation of Registration by Legal Heir in case of Death [FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Filing_of_Cancellation_of_Registration_by_Legal_Heir_in_case_of_Death_of_Sole_Proprietor.htm",
    },
    {
      title: "Communication between Recipient and Supplier Taxpayers [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_communication.htm",
    },
    {
      title: "Comparison of Liability Declared and ITC Claimed [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=Manual_comparison_of_liability_declared_and_ITC_claimed.htm",
    },
    {
      title: "Declaration for Specified Premises (Annexure VII or VIII) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Manual_Declaration_for_Specified_Premises.htm",
    },
    {
      title: "Details of the machines (SRM) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_GST_SRM_htm.htm",
    },
    {
      title: "Engage/ Disengage GST Practitioner [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/taxpayersdashboard/#t=Engage_and_Disengage_GST_Practitioner_manual.htm",
    },
    {
      title: "Enrolling as a GST Practitioner [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/gstp/index.htm#t=Enrolling_as_a_GST_Practitioner_manual.htm",
    },
    {
      title: "Filing an Appeal against Assessment - Demand Order (GST APL-01) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=appeal_manual.htm",
    },
    {
      title: "Filing an Appeal against Assessment - Non Demand Order (GST APL-01) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=appeal3_manual.htm",
    },
    {
      title: "Filing an Appeal against Enforcement Order (GST APL-01) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=Manual_Filing_an_Appeal_against_Enforcement_Order.htm",
    },
    {
      title: "Filing an Appeal against Manual Order (GST APL-01) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=Manual_Manual_order.htm",
    },
    {
      title: "Filing an Appeal against Others Order (GST APL-01) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=Manual_Others_Order.htm",
    },
    {
      title: "Filing an Appeal against Refund Order (GST APL-01) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=appeal2_manual.htm",
    },
    {
      title: "Filing an Appeal against Registration Order (GST APL-01) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=appeal1_manual.htm",
    },
    {
      title: "Filing an Appeal against Wavier Application Rejection Order (SPL - 07) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=Manual_Filing_an_Appeal_against_Waiver_Application_Rejection_Order.htm",
    },
    {
      title: "Filing an intimation of payment (GST DRC-03) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/demandsandrecovery/index.htm#t=Manual_GST_FORM_DRC-03.htm",
    },
    {
      title: "Filing and Viewing Form GST PMT-09 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/ledgers/index.htm#t=Manual_pmt09.htm",
    },
    {
      title: "Filing Application for Compounding of Offence (GST CPD-01) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/prosecution/index.htm#t=Manual_file_application_for_compunding.htm",
    },
    {
      title: "Filing Application for Rectification or Taking Action in the Subsequent Proceedings u/s 161 Conducted by Tax Officer [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=manual_Rectification_of_Order.htm",
    },
    {
      title: "Filing Application for Restoration of Provisional Attachment [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=Manual_provisional_attachmemt.htm",
    },
    {
      title: "Filing Application for Withdrawal of Summary Assessment Order (GST ASMT-17) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=manual_Withdrawal_of_Summary_Assessment_Order.htm",
    },
    {
      title: "Filing Declaration by GTA (Annexure V or VI) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/taxpayersdashboard/#t=Manual_Online_Filing_of_Annexure_V_by_GTA.htm",
    },
    {
      title: "Filing details of Outward Supplies of Goods or Services in GSTR-1 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Creation_of_Outward_Supplies_Return_in_GSTR-1.htm",
    },
    {
      title: "Filing Letter of Undertaking (GST RFD-11) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Furnishing_of_Letter_of_Undertaking.htm",
    },
    {
      title: "Filing Payment Related Grievances (GST PMT-07) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/payments/index.htm#t=Filing_Payment_Related_Grievances_(PMT-07)_Manual.htm",
    },
    {
      title: "Filing Reply and Rectification Request during Proceedings and Order of First Appeal [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=Manual_appeal_order.htm",
    },
    {
      title: "Filing Reply and Rectification Request during Revision Order Proceedings [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/appeal/index.htm#t=Taking_Action_in_Revision_Order_Proceedings_manual.htm",
    },
    {
      title: "Filing Reply for Proceedings initiated for Remanded Cases [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=Manual_remanded_cases.htm",
    },
    {
      title: "Filing Reply in GST ASMT-11 to the Notice issued against Scrutiny of Returns [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=Manual_scrutiny.htm",
    },
    {
      title: "Filing Reply or Taking Actions during Penalty Proceedings u/s 122, 123, 124, 125 and 127 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=FAQs_GP.htm",
    },
    {
      title: "Filing reply to GST DRC-22 against proceedings initiated for recovery of taxes [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/demandsandrecovery/index.htm#t=manual_recovery_from_taxpayer.htm",
    },
    {
      title: "Filing Response to Intimation/Notice/Statement for Proceedings related to Determination of Tax [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=Manual_drc.htm",
    },
    {
      title: "Filing Response to Notice for Proceedings related to Tax Collected but not Deposited [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=Manual_tax_collected.htm",
    },
    {
      title: "Filing TDS and TCS Credit Received [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=manual_tds_and_tcs_credit_received.htm",
    },
    {
      title: "Final Return in GSTR-10 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_GSTR-10.htm",
    },
    {
      title: "Form GST SRM - I [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_GST_SRM_FORM.htm",
    },
    {
      title: "Form GST SRM - II [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_GST_SRM_FORM_II.htm",
    },
    {
      title: "Form GSTR-9C [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_9c.htm",
    },
    {
      title: "Form to Change Profile for Quarterly Return and Monthly Payments (QRMP) Scheme [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=manual_change_profile.htm",
    },
    {
      title: "Furnishing Documents in Invoice Furnishing Facility (IFF) under QRMP Scheme [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_IFF.htm",
    },
    {
      title: "GST ITC-01: ITC Claim u/s 18(1)(a) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=GST_ITC-01.htm",
    },
    {
      title: "GST ITC-01: ITC Claim u/s 18(1)(b) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=Claim_made_under_Section_18_(1)_(b).htm",
    },
    {
      title: "GST ITC-01: ITC Claim u/s 18(1)(c) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=Claim_made_under_Section_18_(1)_(c).htm",
    },
    {
      title: "GST ITC-01: ITC Claim u/s 18(1)(d) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=Claim_made_under_Section_18_(1)_(d).htm",
    },
    {
      title: "GST ITC-02 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=GST_ITC-02_manual.htm",
    },
    {
      title: "GST ITC-02A [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=Manual_2a.htm",
    },
    {
      title: "GST ITC-03 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=Manual_ITC-03.htm",
    },
    {
      title: "GST ITC-04 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=Manual_itc04.htm",
    },
    {
      title: "GST News & Updates",
      href: "https://services.gst.gov.in/services/advisory/advisoryandreleases",
    },
    {
      title: "GST Portal Common Errors & Suggested Solutions",
      href: "https://services.gst.gov.in/services/errorDescription",
    },
    {
      title: "GST TRAN-1 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=GST_TRAN_-_1_Manual.htm",
    },
    {
      title: "GST TRAN-2 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=GST_TRAN_-_2.htm",
    },
    {
      title: "GST TRAN-3 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=GST_TRAN_-3_Manual.htm",
    },
    {
      title: "GSTN Informational Videos",
      href: "https://youtube.com/@goodsandservicestaxnetwork?si=1xF7TnUOdxhBoomS",
    },
    {
      title: "Importing e-Way Bill Data in Form GSTR-1 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_Importing_e-Way_Bill_Data_in_Form_GSTR-1.htm",
    },
    {
      title: "Invoice Management System [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_IMS_Dashboard.htm",
    },
    {
      title: "Monthly Return in GSTR-3B [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Create_and_Submit_GSTR3B.htm",
    },
    {
      title: "Monthly/Quarterly Auto Drafted Static ITC Statement in GSTR-2B [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_gstr2b.htm",
    },
    {
      title: "Opt for Composition Levy [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Composition_Scheme.htm",
    },
    {
      title: "Performing Activities on Taxpayer's Behalf by GST Practitioner [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/gstp/index.htm#t=Accessing_Taxpayer_s_Session_Manual.htm",
    },
    {
      title: "Provisional Assessment and Release of Security [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=Manual_Provisional_Assessmentl.htm",
    },
    {
      title: "Receiving Intimation of ITC Blocked by Tax Official [FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=Receiving_Intimation_of_ITC_Blocked_by_Tax_Official.htm",
    },
    {
      title: "Refund Application (By Embassies/ International Organizations) (GST RFD-10) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Refund_Application_(By_Embassies__International_Organizations).htm",
    },
    {
      title: "Refund by Recipient of Deemed Export [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Refund_by_Recipient_of_deemed_export_(RFD-01A).htm",
    },
    {
      title: "Refund by Supplier of Deemed Export [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=deemed_export_manual.htm",
    },
    {
      title: "Refund Claim by Unregistered Taxpayer [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Manual_RFD01_Unregistered_Taxpayer.htm",
    },
    {
      title: "Refund of Excess Balance in Electronic Cash Ledger [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Application_for_Refund_manual.htm",
    },
    {
      title: "Refund of ITC accumulated due to Inverted Tax Structure [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Refund_of_ITC_accumulated_due_to_inverted_tax_structure_(RFD-01A).htm",
    },
    {
      title: "Refund of ITC on Account of Exports Without Payment of Tax [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Refund_of_ITC_paid_on_Exports_of_Goods_and_Services.htm",
    },
    {
      title: "Refund on Account of Any Other Ground of Reason [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Manual_other.htm",
    },
    {
      title: "Refund on Account of Assessment/Provisional Assessment/Appeal/Any Other Order [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Refund_on_account_of_Assessment_manual.htm",
    },
    {
      title: "Refund on Account of Excess Payment of Tax [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Manual_excess.htm",
    },
    {
      title: "Refund on Account of Export of Goods (With Payment of Tax) [FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Refund_on_Account_of_Export_of_Goods_(With_Payment_of_Tax).htm",
    },
    {
      title: "Refund on Account of Export of Services (With Payment of Tax) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Refund_on_Account_of_Export_of_Services_(With_Payment_of_Tax)_manaul.htm",
    },
    {
      title: "Refund on Account of Supplies made to SEZ Unit/Developer (With Payment of Tax) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Refund_on_Account_of_Supplies_made_to_SEZ_Unit__WPT_manual.htm",
    },
    {
      title: "Refund on Account of Supplies made to SEZ Unit/Developer (Without Payment of Tax) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Refund_on_Account_of_Supplies_made_to_SEZ_Unit_wipt_manual.htm",
    },
    {
      title: "Refund on Inward Supplies of Goods by CSD [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Manual__Refund_on_Inward_Supplies_by_CSD.htm",
    },
    {
      title: "Refund on Tax paid on an Intra-State Supply which is subsequently held to be Inter-State Supply and Vice Versa [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=tax_pain_on_intra_state_supply_manual.htm",
    },
    {
      title: "Return Compliance for the Form DRC-01B Part B [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_Return_Compliance.htm",
    },
    {
      title: "Return Compliance in DRC-01C (Intimation of difference in ITC available and ITC claimed) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_Return_Compliance_ITC.htm",
    },
    {
      title: "Return for ISD in GSTR-6 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=GSTR-6.htm",
    },
    {
      title: "Return for Tax Collected at Source in GSTR-8 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_GSTR-8.htm",
    },
    {
      title: "Return for Tax Deducted at Source in GSTR-7 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=GSTR7_Manual.htm",
    },
    {
      title: "Return to be furnished by NRTP in GSTR-5 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=GSTR-5.htm",
    },
    {
      title: "Return to be furnished by OIDAR in GSTR-5A [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=GSTR-5A.htm",
    },
    {
      title: "Revocation of Cancelled Registration [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Revocation_of_Cancelled_Registration.htm",
    },
    {
      title: "Search ARA/AAAR Orders [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/advanceruling/index.htm#t=Manual_Search_Orders_Advance_Ruling_Authority_Appellate_Authority_for_Advance_Ruling.htm",
    },
    {
      title: "Search HSN/SAC",
      href: "https://services.gst.gov.in/services/searchhsnsac",
    },
    {
      title: "Statement for Payment of Self-Assessed Tax in CMP-08 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_CMP02.htm",
    },
    {
      title: "Statement of Inward Supplies by UIN Holder in GSTR-11 [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manua_GSTR-11.htm",
    },
    {
      title: "Statement of Inward Supplies for an ISD in GSTR-6A [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=GSTR-6A.htm",
    },
    {
      title: "Submitting Intimation on Account of Refund Not Received [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=Manual_refund_not_received_intimation.htm",
    },
    {
      title: "Submitting Refund Pre-Application Form [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=manual_refundpreapplication.htm",
    },
    {
      title: "Suo Moto Cancellation of Registration by Tax Officials [FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/registration/index.htm#t=Suo_Moto_Cancellation.htm",
    },
    {
      title: "Unblocking of E-Way Bill Generation Facility [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_ewaybill.htm",
    },
    {
      title: "Utilization of Electronic Cash and ITC Ledger [FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/inputtaxcredit/index.htm#t=Utilization_Principles.htm",
    },
    {
      title: "View/Download Certificate in GSTR-7A [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/returns/index.htm#t=Manual_GSTR7A.htm",
    },
    {
      title: "View/Download Notices and Demand Orders [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/taxpayersdashboard/#t=View_Notices_and_Demand_Orders.htm",
    },
    {
      title: "Viewing Demand Uploaded by Tax Official under Pre-GST Laws (GST DRC-07A & GST DRC-08A) [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/demandsandrecovery/index.htm#t=Manual_drc07a.htm",
    },
    {
      title: "Viewing Issued Notice, Filing Reply and Taking Subsequent Actions during Audit Proceedings [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/audit/index.htm#t=Manual_audit.htm",
    },
    {
      title: "Viewing Notices and Orders, during Assessment Proceedings u/s 63, by an Unregistered Person [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/assessment/index.htm#t=FAQs_UP.htm",
    },
    {
      title: "Viewing Notices/Orders and File Reply to query on Refund Application [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=File_reply_manual.htm",
    },
    {
      title: "Viewing Prosecution Notice Issued by Tax Officials [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/prosecution/index.htm#t=Manual_view_notice.htm",
    },
    {
      title: "Withdrawing Filed Refund Application [User Manual & FAQ's]",
      href: "https://tutorial.gst.gov.in/userguide/refund/index.htm#t=manual_withdraw_refund.htm",
    },
  ],
};

export default indirectTax;
